import { render, staticRenderFns } from "./zelle.vue?vue&type=template&id=9b9ead0c&"
import script from "./zelle.vue?vue&type=script&lang=js&"
export * from "./zelle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports